export const DEVICE_TYPE_LABELS = ['unknown', 'phone', 'tablet', 'desktop', 'tv'];
